import { gql } from '@apollo/client';

export interface SignInResults {
  signIn: {
    accessToken: string;
    refreshToken: string;
  };
}

export const SIGNIN = gql`
  mutation signIn($input: SignInInput!) {
    signIn(input: $input) {
      accessToken
      clientMutationId
      refreshToken
    }
  }
`;
